import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
const New = () => {
    let history = useHistory();
    const handleNext = (e) => {
        e.preventDefault();
        sessionStorage.removeItem('uniqueResponse' +'0'); sessionStorage.removeItem('questionResponses' + '0');
        history.push('form/0/meta');
    }
        return (
       <div>
                <div className="content">                          
                    <h2>How to use the DUC Tool</h2>
                    <ol>
                        <li>Follow the prompts to <strong>reflect</strong> on your chosen subject site.<br /><br /></li>
                        <li><strong>Export</strong> your summary.<br />
                            <em>On the final screen of the tool, a summary of your responses will be displayed. You will be able to export this summary as a PDF or email.</em><br /><br />
                            <em>Included in this summary is a randomly generated, unique ID number. This number will be required to retrieve and/or update a completed DUC.</em><br />
                            <div class="call-to-action"><strong>Note:</strong> Your responses will remain anonymous so to view them later you'll need to save a copy on the final screen.</div>

                        </li>
                        <li><strong>Access support materials</strong> and uplift your site.<br />
                            <em>Your summary will include links to curated resources to support the enhancement of your online learning environment.</em><br /><br />
                        </li>
                        <li><strong>Update</strong> your DUC<br />
                            <em>Return to the tool to update you DUC summary.</em>
                        </li>
                    </ol>
                  
            </div>

            <div className="page-nav">
                    <div><a href="home" className="link-small-back"> Back</a></div>
                    <div><a href="#" className="link-small" onClick={handleNext}> Next</a></div>
            </div>
        </div>                            
                     



        )
   
}
export default New;